// Re-export components for external use
export { AuthErrorAlert } from './auth-error-alert';
export { AuthRecoveryHint } from './auth-recovery-hint';
export { PasswordSignInForm } from './password-sign-in-form';
export { PasswordSignInContainer } from './password-sign-in-container';
export {
  isAccountExistsError,
  isInvalidCredentialsError,
} from '../lib/auth-error-matchers';
